module.exports = __webpack_public_path__ + "img/ri_6.1d35643c.png";